export enum LanguageEnum {
  Afrikaans = 'AFRIKAANS',
  Albanais = 'ALBANAIS',
  Allemand = 'ALLEMAND',
  Amharique = 'AMHARIQUE',
  Anglais = 'ANGLAIS',
  Arabe = 'ARABE',
  Araona = 'ARAONA',
  Armenien = 'ARMENIEN',
  Aymara = 'AYMARA',
  Azeri = 'AZERI',
  Basque = 'BASQUE',
  Baure = 'BAURE',
  Bengali = 'BENGALI',
  Besiro = 'BESIRO',
  Bichelamar = 'BICHELAMAR',
  Bielorusse = 'BIELORUSSE',
  Birman = 'BIRMAN',
  Bulgare = 'BULGARE',
  Canichana = 'CANICHANA',
  Cantonais = 'CANTONAIS',
  Catalan = 'CATALAN',
  Cavinena = 'CAVINENA',
  Cayubaba = 'CAYUBABA',
  Chacobo = 'CHACOBO',
  Chichewa = 'CHICHEWA',
  Chimane = 'CHIMANE',
  Chinois = 'CHINOIS',
  Cinghalais = 'CINGHALAIS',
  Coreen = 'COREEN',
  CreoleGuinee = 'CREOLE_GUINEE',
  CreoleHaitien = 'CREOLE_HAITIEN',
  CreoleSeychellois = 'CREOLE_SEYCHELLOIS',
  Croate = 'CROATE',
  Danois = 'DANOIS',
  Divehi = 'DIVEHI',
  Dothraki = 'DOTHRAKI',
  Dzongkha = 'DZONGKHA',
  EseEjja = 'ESE_EJJA',
  Espagnol = 'ESPAGNOL',
  Estonien = 'ESTONIEN',
  Fidjien = 'FIDJIEN',
  Filipino = 'FILIPINO',
  Finnois = 'FINNOIS',
  Francais = 'FRANCAIS',
  Georgien = 'GEORGIEN',
  Gilbertin = 'GILBERTIN',
  Grec = 'GREC',
  Guarani = 'GUARANI',
  Guarasuwe = 'GUARASUWE',
  Guarayu = 'GUARAYU',
  Hebreu = 'HEBREU',
  Hindi = 'HINDI',
  Hindoustani = 'HINDOUSTANI',
  HiriMotu = 'HIRI_MOTU',
  Hongrois = 'HONGROIS',
  Iban = 'IBAN',
  Indonesien = 'INDONESIEN',
  Irlandais = 'IRLANDAIS',
  Islandais = 'ISLANDAIS',
  Italien = 'ITALIEN',
  Itonama = 'ITONAMA',
  Japonais = 'JAPONAIS',
  Kallawaya = 'KALLAWAYA',
  Kazakh = 'KAZAKH',
  Khmer = 'KHMER',
  Kichwa = 'KICHWA',
  Kirghiz = 'KIRGHIZ',
  Kirundi = 'KIRUNDI',
  Kiswahili = 'KISWAHILI',
  LangueDesSignes = 'LANGUE_DES_SIGNES',
  Lao = 'LAO',
  Latin = 'LATIN',
  Leko = 'LEKO',
  Letton = 'LETTON',
  Lituanien = 'LITUANIEN',
  Luxembourgeois = 'LUXEMBOURGEOIS',
  Macedonien = 'MACEDONIEN',
  Machineri = 'MACHINERI',
  Malais = 'MALAIS',
  Malgache = 'MALGACHE',
  Mandarin = 'MANDARIN',
  Maori = 'MAORI',
  Maropa = 'MAROPA',
  Marshallais = 'MARSHALLAIS',
  Mirandais = 'MIRANDAIS',
  MojenoIgnaciano = 'MOJENO_IGNACIANO',
  Mongol = 'MONGOL',
  Montenegrin = 'MONTENEGRIN',
  More = 'MORE',
  Moseten = 'MOSETEN',
  Movima = 'MOVIMA',
  Nauruan = 'NAURUAN',
  Neerlandais = 'NEERLANDAIS',
  Nepalais = 'NEPALAIS',
  Norvegien = 'NORVEGIEN',
  Ourdou = 'OURDOU',
  Ouzbek = 'OUZBEK',
  Pacahuara = 'PACAHUARA',
  Pachto = 'PACHTO',
  Paluan = 'PALUAN',
  Persan = 'PERSAN',
  Polonais = 'POLONAIS',
  Portugais = 'PORTUGAIS',
  Puquina = 'PUQUINA',
  Quechua = 'QUECHUA',
  Roumain = 'ROUMAIN',
  Russe = 'RUSSE',
  Samoan = 'SAMOAN',
  Sango = 'SANGO',
  Serbe = 'SERBE',
  Sesotho = 'SESOTHO',
  Shikomor = 'SHIKOMOR',
  Shona = 'SHONA',
  Shuar = 'SHUAR',
  Sindebele = 'SINDEBELE',
  Siriono = 'SIRIONO',
  Slovaque = 'SLOVAQUE',
  Slovene = 'SLOVENE',
  Somali = 'SOMALI',
  Suedois = 'SUEDOIS',
  Tacana = 'TACANA',
  Tadjik = 'TADJIK',
  Taiwanais = 'TAIWANAIS',
  Tamazight = 'TAMAZIGHT',
  Tamoul = 'TAMOUL',
  Tapiete = 'TAPIETE',
  Tcheque = 'TCHEQUE',
  Tetoum = 'TETOUM',
  Thai = 'THAI',
  Tigrinya = 'TIGRINYA',
  TokPisin = 'TOK_PISIN',
  Tonguien = 'TONGUIEN',
  Toromona = 'TOROMONA',
  Turc = 'TURC',
  Turkmene = 'TURKMENE',
  Tuvaluan = 'TUVALUAN',
  Ukrainien = 'UKRAINIEN',
  UruChipaya = 'URU_CHIPAYA',
  Vietnamien = 'VIETNAMIEN',
  Wichi = 'WICHI',
  Yaminahua = 'YAMINAHUA',
  Yaracare = 'YARACARE',
  Yuki = 'YUKI',
}
